<script>
  import {fadeFly} from "../transition/fadeFly";
  import _ from 'lodash';

  export let visible = false;
  export let message;
  export let actions = [];

  let maxWidth = Math.min(window.innerWidth, 600);

  const onResize = e => {
    maxWidth = Math.min(window.innerWidth, 600);
  };
</script>

<svelte:window on:resize={onResize}></svelte:window>

{#if visible}

  <div class="snackbar-wrapper" style="max-width: {maxWidth}px;">
    <div class="snackbar" transition:fadeFly={{
      y: 60
    }}>
      <row>
        <div class="message expand">{message}</div>
          {#if !_.isEmpty(actions)}
            <div class="divider"></div>
              {#each actions as action}
<!--TODO: implement-->
              {/each}
          {/if}

      </row>
    </div>
  </div>
{/if}

<style>
  .snackbar-wrapper {
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 0);
    min-width: 200px;
  }

  .snackbar {
    background-color: black;
    color: #eee;
    padding: 12px;
    margin: 12px;
    box-shadow: 0 0 2px 0 #ccc;
  }

  .message {
    text-align: center;
  }
</style>